export function GetDevicesOfType(types, devicesList) {
  if (!types) return;
  if (!Array.isArray(types)) types = [types];

  return devicesList.filter((device) => types.includes(device.device_type));
}
